// extracted by mini-css-extract-plugin
module.exports = {"label":"index-module__label___sKerA","input":"index-module__input___jGTFI","checked":"index-module__checked___m+7KP","text":"index-module__text___b-WQ+"};